import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable, of } from 'rxjs';
import { IStepRequest } from '../models/ui/job-request/job-request.model';
import { ProcessingStep } from '../models/ui/processing-step.model';
import { ProcessingActiveStepDetailsResponseResource } from '../models/resource/processing-active-step-details-response.resource';
import { map } from 'rxjs/operators';
import { ProcessingActiveStepDetailsResponseResourceToProcessingStepMapper } from '../models/mappers/processing-active-step-details-response-resource-to-processing-step.mapper';
import { StepActionRequestResource } from '../models/ui/job-request/step-action-request.resource';
import { ProcessingActiveStepResource } from '../models/resource/processing-active-step.resource';
import { ProcessingActiveStepResourceToProcessingStepMapper } from '../models/mappers/processing-active-step-resource-to-processing-step.mapper';

@Injectable({
	providedIn: 'root'
})
export class ProcessingQueueSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getStep(params?: GetParams): Observable<ProcessingStep> {
		if (!params?.id) {
			return of(null);
		}

		return this.makeHttpRequest<ProcessingActiveStepDetailsResponseResource>('get', `api2/step/${ params.id }`).pipe(
			map((response) => {
				const mapper = new ProcessingActiveStepDetailsResponseResourceToProcessingStepMapper();
				return mapper.map(response);
			})
		);
	}

	public schedule(params?: ScheduleParams): Observable<void> {
		if (!params?.stepRequest) {
			return of(null);
		}

		return this.makeHttpRequest('post', 'api2/steps/schedule', params.stepRequest);
	}

	public action(params?: ActionParams): Observable<void> {
		if (!params?.action) {
			return of(null);
		}

		return this.makeHttpRequest('post', 'api2/steps/action', params.action);
	}

	public getSnapshot(): Observable<ProcessingStep[]> {
		return this.makeHttpRequest<ProcessingActiveStepResource[]>('get', 'api2/steps/snapshot').pipe(
			map((response) => {
				const mapper = new ProcessingActiveStepResourceToProcessingStepMapper();
				return mapper.mapCollection(response);
			})
		)
	}

}

interface ScheduleParams {
	stepRequest: IStepRequest;
}

interface ActionParams {
	action: StepActionRequestResource;
}

interface GetParams {
	id: string;
}


